import { render, staticRenderFns } from "./CoreBread.vue?vue&type=template&id=39169568&"
import script from "./CoreBread.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreBread.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39169568')) {
      api.createRecord('39169568', component.options)
    } else {
      api.reload('39169568', component.options)
    }
    module.hot.accept("./CoreBread.vue?vue&type=template&id=39169568&", function () {
      api.rerender('39169568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreBread/CoreBread.vue"
export default component.exports